import { navigationContent } from '../app/navigation-content'
import useNavigateToDiary from '../../diaries/hooks/useNavigateToDiary'

const useNavigationContent = () => {
  const { navigateToDiary, diaryWord } = useNavigateToDiary()

  // Map over navigationContent and inject onClick for Diaries
  const dynamicNavigation = navigationContent.map((item) => {
    if (item.href === "/diaries") {
      return {
          ...item,
        name: diaryWord,
        onClick: navigateToDiary,
      }
    }
    return item
  })

  return dynamicNavigation
}

export default useNavigationContent